import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import apiRequest from "../../../../utils/admin/apiRequest";
import usePost from "../../../../hooks/api/usePost";
import Alert from "../../../ui/utils/Alert";
import InputField from "../../../ui/form/InputField";
import CheckboxField from "../../../ui/form/CheckboxField";
import Button from "../../../ui/utils/Button";
import AsyncSearchSelect from "../../../ui/form/AsyncSearchSelect";

const Create = ({ closeModal, callback }) => {
  const { error, isLoading, post, serverErrors } = usePost(
    apiRequest.createVendorManagerPaymentGateway
  );

  const formik = useFormik({
    initialValues: {
      vendorManagerId: "",

      razorpay: {
        isEnabled: true,
        keyId: "",
        keySecret: "",
        webhookSecret: "",
      },

      scanToPay: {
        isEnabled: true,
        upiId: "",
        payeeName: "",
        qrImage: "",
      },

      isActive: true,
    },

    validationSchema: Yup.object({

      razorpay: Yup.object({
        isEnabled: Yup.boolean(),
        keyId: Yup.string().when("isEnabled", {
          is: true,
          then: (s) => s.required("Key ID required"),
        }),
        keySecret: Yup.string().when("isEnabled", {
          is: true,
          then: (s) => s.required("Key Secret required"),
        }),
      }),

      scanToPay: Yup.object({
        isEnabled: Yup.boolean(),
        upiId: Yup.string().when("isEnabled", {
          is: true,
          then: (s) => s.required("UPI ID required"),
        }),
      }),
    }),

    onSubmit: async (values, { resetForm }) => {
      const payload = {
        vendorManagerId: values.vendorManagerId,
        razorpay: values.razorpay.isEnabled ? values.razorpay : undefined,
        scanToPay: values.scanToPay.isEnabled ? values.scanToPay : undefined,
        isActive: values.isActive,
      };

      const response = await post({ data: { body: payload } });

      if (response?.response) {
        callback?.();
        resetForm();
        closeModal();
      }
    },
  });

  const fetchVendors = async (search) => { const res = await apiRequest.getVendorManagerForSelect({ body: { filters: { name: { $regex: search, $options: "i" }, }, paginate: false, }, }); return (res?.data?.data?.vendors?.map((v) => ({ label: v.label, value: v.value, })) || []); };

  return (
    <div>
      <h2 className="p-4 text-lg font-semibold">
        Create Vendor Payment Gateway
      </h2>

      <div className="border-b" />

      <form onSubmit={formik.handleSubmit} className="text-sm">
        {error && <Alert message={error} type="error" />}

        <div className="grid grid-cols-1 gap-3 p-4 sm:grid-cols-2">
          <div className="col-span-full">

            <div className="grid grid-cols-2">
              <CheckboxField
                label="Enable Razorpay"
                checked={formik.values.razorpay.isEnabled}
                onChange={(e) =>
                  formik.setFieldValue(
                    "razorpay.isEnabled",
                    e.target.checked
                  )
                }
              />

              <CheckboxField
                label="Enable Scan to Pay (UPI)"
                checked={formik.values.scanToPay.isEnabled}
                onChange={(e) =>
                  formik.setFieldValue(
                    "scanToPay.isEnabled",
                    e.target.checked
                  )
                }
              />

            </div>



          </div>
          <AsyncSearchSelect
            label="Vendor Manager"
            name="vendorManagerId"
            value={formik.values.vendorManagerId}
            onChange={formik.handleChange}
            fetchOptions={fetchVendors}
            placeholder="Search Vendor Manager"
            error={formik.touched.vendorManagerId && formik.errors.vendorManagerId}
          />


          {formik.values.razorpay.isEnabled && (
            <>
              <InputField
                name="razorpay.keyId"
                label="Razorpay Key ID"
                value={formik.values.razorpay.keyId}
                onChange={formik.handleChange}
                error={formik.errors?.razorpay?.keyId}
              />

              <InputField
                type="password"
                name="razorpay.keySecret"
                label="Razorpay Key Secret"
                value={formik.values.razorpay.keySecret}
                onChange={formik.handleChange}
                error={formik.errors?.razorpay?.keySecret}
              />

              <InputField
                name="razorpay.webhookSecret"
                label="Webhook Secret"
                value={formik.values.razorpay.webhookSecret}
                onChange={formik.handleChange}
              />
            </>
          )}

          {/* Scan to Pay Toggle */}


          {formik.values.scanToPay.isEnabled && (
            <>
              <InputField
                name="scanToPay.upiId"
                label="UPI ID"
                placeholder="vendor@upi"
                value={formik.values.scanToPay.upiId}
                onChange={formik.handleChange}
                error={formik.errors?.scanToPay?.upiId}
              />

              <InputField
                name="scanToPay.payeeName"
                label="Payee Name"
                value={formik.values.scanToPay.payeeName}
                onChange={formik.handleChange}
              />
            </>
          )}

          <CheckboxField
            label="Is Active"
            checked={formik.values.isActive}
            onChange={(e) =>
              formik.setFieldValue("isActive", e.target.checked)
            }
          />
        </div>

        <div className="border-b" />

        <div className="flex justify-end gap-2 p-4">
          <Button variant="secondary" onClick={closeModal}>
            Cancel
          </Button>

          <Button
            type="submit"
            variant="primary"
            isLoading={isLoading}
            loadingText="Creating..."
          >
            Create
          </Button>
        </div>
      </form>
    </div>
  );
};

export default Create;
